import style from "./LoadingDots.module.scss";
import { CSSProperties } from "react";
interface Props {
  bgColor: string;
  color?: string;
}
const LoadingDots = ({
  bgColor,
  color
}: Props) => {
  return <div className={style.loadingDots_wrapper} style={{
    "--bgColor": bgColor,
    "--color": color
  } as CSSProperties} data-sentry-component="LoadingDots" data-sentry-source-file="LoadingDots.tsx">
      Loading
      <div className={style.loading_dots}>
        <div className={style.loading_dots__dot}></div>
        <div className={style.loading_dots__dot}></div>
        <div className={style.loading_dots__dot}></div>
      </div>
    </div>;
};
export default LoadingDots;